export default {
  all: [
    {
      id: 1,
      status: 'Active',
      subscriberId: 1,
      tagNumber: '7118813',
      TagDesc: '7118813',
      reserved: 0,
      reservedForId: 0,
      modifiedAt: '01/01/2000',
      isAvailable: 1
    }
  ]
}
